 (function () {
  if (window.subscriptionUpgradeAdded) return;
  window.subscriptionUpgradeAdded = true;

  document.addEventListener(
    "click",
    async function (e) {
      const btn = e.target.closest(".upgrade-to-subscription-btn");
      if (!btn) return;

      e.preventDefault();
      e.stopPropagation();

      const cartItem = btn.closest("[data-cart-item]");
      if (!cartItem) return;

      const variantId = btn.dataset.variantId;
      const sellingPlanId = btn.dataset.sellingPlanId;
      const lineKey = cartItem.getAttribute("data-item"); // Shopify line_item.key

      const qtyInput = cartItem.querySelector("[data-quantity-field]");
      const quantity = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;

      if (!variantId || !sellingPlanId || !lineKey) return;

      btn.innerText = "Upgrading…";
      btn.style.pointerEvents = "none";
      btn.style.opacity = "0.6";

      try {
        // 1) Remove existing non-subscription line by key
        await fetch("/cart/change.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: lineKey, quantity: 0 }),
        }).then((res) => res.json());

        // 2) Add back same variant with selling plan
        await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            id: parseInt(variantId, 10) || variantId,
            quantity: quantity,
            selling_plan: parseInt(sellingPlanId, 10) || sellingPlanId,
          }),
        }).then((res) => res.json());

        // 3) Tell Palo Alto cart to reload via its own API
        if (window.cart && typeof window.cart.getCart === "function") {
          window.cart.getCart();
        } else {
          // Fallback: fire theme-wide cart update event
          document.dispatchEvent(new CustomEvent("theme:cart:update"));
        }
      } catch (err) {
        console.error("Upgrade failed:", err);
        btn.innerText = "Upgrade to Subscription";
        btn.style.pointerEvents = "auto";
        btn.style.opacity = "1";
      }
    },
    true
  );
})();